import React, { useState, useEffect } from "react";
import { Card, Col, Row, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import API_KEY from "../../../../api";
import CategoryCardImages from "./CategoryCardImages";
import { useHistory } from "react-router-dom";
import { gaEvent } from "../../../../analytics/analytics";
import * as GA from "../../../../constants/analytics";
import { filters } from "store/actions/filters";
import { useGlobal } from "store/index";
const { Text, Title } = Typography;
export default function CategoryCard({ item }) {
  const [product, setProduct] = useState(null);
  const [count, setCount] = useState(0);
  const history = useHistory();


  const [globalState, globalActions] = useGlobal();
  const [spinning, setSpinning] = useState(false);
  const { isOnboarding,permissions,loading } = globalState;

  var defaultFilter = {
    'secondary_category': {
      "_eq": item?.id
    }
  }

  var userFilter = null
  var userId = localStorage.getItem("userId");
  var isAdmin = localStorage.getItem("isAdmin");
  
  if (permissions?.permissions.length > 0  & isAdmin==="false"){
    var check_current_user = permissions?.permissions.filter(el => el?.slug === 'view_products' & el?.subPermission?.values?.includes('current_user'))
    if (check_current_user.length > 0){
      userFilter = {"user_id":{"_eq": userId} };
    }
  }

  var allFilters = [defaultFilter]
  if(userFilter!=null){
    allFilters.push(userFilter)
  }

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    API_KEY.URL.get(API_KEY.path.products, {
      params: {
        // "filter[secondary_category][_eq]": item?.id +"&filter[user_id]['_eq']=1",
        fields: "product_images.directus_files_id",
        meta: "filter_count",
        limit:3,
        sort:"-date_created",
        filter: {
          "_and": allFilters
          }
      },
    })
      .then((res) => {
        setProduct(res.data?.data);
        setCount(res?.data?.meta?.filter_count);
      })
      .catch((error) => console.log(error));
  }, [item]);
  return (
    <Col xs={24} sm={24} md={12} lg={8} xl={6} style={{ marginTop: "1rem" }}>
      <Card
        key={item?.id}
        bordered
        className="category-card"
        style={{ marginRight: "1rem" }}
        onClick={() => {
          history.push(`/categorywise-products/${item?.name}/${item?.id}`);
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.EACH_CATEGORY_CARD_OPENED,
            item?.id
          );
        }}
      >
        <Row justify="space-between">
          <Col>
            {" "}
            <Title
              style={{ marginBottom: 0 }}
              level={4}
              className="category-card-title"
            >
              {item?.name}
            </Title>
          </Col>
          <Col>
            {" "}
            <RightOutlined
              className="category-card-icon"
              style={{
                fontSize: "1rem",
                alignSelf: "center",
                padding: "0.2rem",
              }}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Text style={{ marginBottom: "1rem" }} type="secondary">
            {product && count ? `${count} Products` : "Add products"}
          </Text>
        </Row>

        <CategoryCardImages product={product} />
      </Card>
    </Col>
  );
}
